<!--
 * @Author: linrui
 * @Date: 2021-12-21 16:41:33
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-04 15:56:55
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/doctorMsg.vue
-->

<template>
    <div class="progress-msg-box" v-wechat-title="this.statusTitle">
        <div class="img-box">
            <van-icon :name="iconSrc" color="#2aa8b1" size="90px"/>
        </div>
        <p class="progress-msg-title" v-if="title">{{ title }}</p>
        <p class="desc" v-if="desc">{{ desc }}</p>
        <!-- <p class="error-msg" v-if="errorMsg">失败原因：{{ errorMsg }}</p> -->
        <div class="btn" v-if="btnText">
            <van-button class="up" :class="btnText.includes('确认')?'spacing-style':''" @click="goToNext" >{{ btnText }}</van-button>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations
} from "vuex";
import {doctorStatus} from '@/utils/doctorStatus'

export default {
    data() {
        return {
            statusTitle:'提交成功',//动态标题
            btnText:'',//按钮标题
            iconSrc:'',//消息图片
            desc:'',//审核描述
            title:'',//审核状态标题
            // errorMsg:'',//错误信息提示
            category:'',//重新上传材料的分类
            nextStep:'',//下一步跳转的页面类别
            statusInfo: {
                title: '',
                desc: '',
            }
        }
    },
    computed: {
        ...mapState({
            doctorInfo:state => state.doctor.doctorInfo
        }),
    },
    created() {
        let  doctorInfoTitle = '审核状态'
        let  recordTitle = '项目医生备案'
        let  sealTitle = '印章接收'
        this.statusInfo = doctorStatus(this.doctorInfo)
        if (this.$route.query.value == '医生提交') {//初审通过提示信息
            this.statusTitle = doctorInfoTitle
            this.iconSrc = 'checked'
            this.title = '提交成功'
            this.desc = `尊敬的${this.doctorInfo.name}医生，您好。感谢您参与“择美同行-患者援助项目”，您的注册信息已递交至项目办进行审核，请您耐心等待，审核结果将会发送至您的手机上。感谢您的理解与支持！`
            this.btnText ='返回'
        } else if(this.$route.query.value == '医生等待审核') {
            this.statusTitle = doctorInfoTitle
            this.iconSrc = 'warning'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您上传的医生信息正在审核中，请耐心等待审核结果，感谢您的支持和配合！`
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.btnText ='返回'
        } else if(this.$route.query.value == '医生审核不通过') {
            this.statusTitle = doctorInfoTitle
            this.iconSrc = 'clear'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您上传的注册信息未通过，请前往医生信息重新填写！`
            // this.errorMsg = this.$route.query.apply_reason
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.nextStep = this.$route.query.next_step
            this.btnText ='前往信息填写'
        } else if(this.$route.query.value == '医生审核拒绝') {
            this.statusTitle = doctorInfoTitle
            this.title = '拒绝申请'
            this.iconSrc = 'clear'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您上传的医生信息未通过。`
            // this.errorMsg = this.$route.query.apply_reason
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.btnText ='返回'
        }else if(this.$route.query.value == '医生审核通过') {
            this.statusTitle = doctorInfoTitle
            this.iconSrc = 'checked'
            this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的注册信息已经审核通过，请您参加培训考试，感谢您的理解与支持！`
            this.nextStep = this.$route.query.next_step
            this.btnText ='前往培训考试'
        } else if(this.$route.query.value == '备案提交') {
            this.statusTitle = recordTitle
            this.title ='提交成功'
            this.iconSrc = 'checked'
            this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的备案材料已提交，请耐心等待审核结果。`
            this.btnText ='返回'
        } else if(this.$route.query.value == '备案已上传') {
            this.statusTitle = recordTitle
            // this.title ='电子备案等待审核中'
            this.iconSrc = 'warning'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您上传的备案信息正在审核中，请耐心等待审核结果，感谢您的支持和配合！`
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.btnText ='返回'
        } else if(this.$route.query.value == '电子审核不通过'){
            this.statusTitle = recordTitle
            // this.title ='电子备案审核不通过'
            this.iconSrc = 'clear'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您上传的备案信息未通过，请重新上传！`
            // this.errorMsg = this.$route.query.record_reason
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.btnText ='前往重新上传'
            this.nextStep = this.$route.query.next_step
        } else if(this.$route.query.value == '电子审核通过'){
            this.statusTitle = recordTitle
            // this.title ='电子备案审核通过'
            this.iconSrc = 'checked'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的电子材料审核已通过，请邮寄纸质材料到以下地址（仅接受EMS特快专递）：北京市100024信箱59号分箱中国初级卫生保健基金会 “择美同行-患者援助项目办公室”，项目联系电话：010-56592455。`
            this.btnText ='返回'
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
        } else if(this.$route.query.value == '纸质审核不通过'){
            this.statusTitle = recordTitle
            this.iconSrc = 'clear'
            // this.title ='纸质材料审核不通过'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的纸质材料审核未通过，请重新邮寄纸质材料到以下地址（仅接受EMS特快专递）：北京市100024信箱59号分箱中国初级卫生保健基金会 “择美同行-患者援助项目办公室”，项目联系电话：010-56592455。`
            // this.errorMsg = this.$route.query.record_reason
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.btnText ='返回'
            // this.nextStep = this.$route.query.next_step
        } 
        // else if(this.$route.query.value == '纸质审核通过'){
        //     this.iconSrc = 'checked'
        //     this.desc = `您好，项目办已经寄出您的“项目专用章“，请您注意查收，查收后请您签署《项目专用章签收回执》并上传，感谢您的配合与支持。`
        // } 
        else if(this.$route.query.value == '印章未制作') {
            this.statusTitle = recordTitle
            // this.title ='纸质材料审核通过'
            this.iconSrc = 'checked'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的纸质备案文件项目办已查收并审核通过，项目办正在为您制作“项目专用章”。感谢您的配合与支持。`
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.btnText ='返回'
        }
        else if(this.$route.query.value == '印章已制作') {
            this.statusTitle = recordTitle
            // this.title ='纸质材料审核通过'
            this.iconSrc = 'checked'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的纸质备案文件项目办已查收并审核通过，项目办已为您制作“项目专用章”。感谢您的配合与支持。`
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.btnText ='返回'
        }
        else if(this.$route.query.value == '印章已发送') {
            this.statusTitle = recordTitle
            // this.title ='纸质材料审核通过'
            this.iconSrc = 'checked'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。项目办已经寄出您的“项目专用章“，快递单号为：${this.$route.query.expressNum}，请您注意查收，查收后请您签署《项目专用章签收回执》并上传，感谢您的配合与支持。`
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.title ='审核通过'
            this.btnText ='前往印章接收'
            this.nextStep = this.$route.query.next_step
        } else if(this.$route.query.value == '签收提交') {
            this.statusTitle = sealTitle
            this.iconSrc = 'checked'
            this.title ='提交成功'
            this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的材料已提交审核，请耐心等待审核结果`
            this.btnText ='返回'
        } else if(this.$route.query.value == '签收等待审核') {
            this.statusTitle = sealTitle
            // this.title ='等待审核中'
            this.iconSrc = 'warning'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您上传的签收文件正在审核中，请耐心等待审核结果，感谢您的支持和配合！`
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
            this.btnText ='返回'
        } else if(this.$route.query.value == '签收审核不通过') {
            this.statusTitle = sealTitle
            // this.title ='审核不通过'
            this.iconSrc = 'clear'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您上传的签收文件未通过，请前往签收表重新上传！`
            // this.errorMsg = this.$route.query.sign_reason
            this.btnText = '重新提交'
            this.nextStep = this.$route.query.next_step
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
        } else if(this.$route.query.value == '签收审核通过') {
            this.statusTitle = sealTitle
            // this.title = '审请通过'
            this.iconSrc = 'checked'
            // this.desc = `尊敬的${this.doctorInfo.name}医生，您好。您上传的项目专用章回执审核已审核通过，您已正式成为“择美同行-患者援助项目"的慈善医生，感谢您对中国慈善事业的支持。`
            this.title = this.statusInfo.title
            this.desc = this.statusInfo.desc
        }
    },
    methods: {
        ...mapMutations(['clearDoctorInfo']),
        //跳转到下一个页面
        goToNext() {
            if(this.nextStep) {
                this.$router.replace({
                    name: this.nextStep
                })
                return
            } else if(this.btnText == '确认' || this.btnText == '返回' || this.btnText == '返回首页') {
                this.$router.replace({
                    name:'DoctorQuery'
                })
                // this.$wechat.closeWindow()
            // } else if(this.btnText == '返回首页') {
            //     this.$wechat.closeWindow()
            }
        }
    }
}
</script>
<style lang="less" scoped>
    .progress-msg-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 57px 0;
        .img-box {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 300px;
            height: 156px;
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }
        .progress-msg-title {
            margin-bottom: 23px;
            color: #101010;
            font-size: 16px;
            font-family: PingFangSC-Medium;    
        }
        .desc {
            color:#101010;
            font-size: 16px;
            text-align: left;
            text-indent: 30px;
            text-align:justify;
            text-justify:inter-ideograp;
            font-family: PingFangSC-Regular;
        }

        .error-msg {
            margin-top: 8px;
            color: #E30A0A;
            font-size: 14px;
            text-align: left;
            text-indent: 10px;
        }

        .btn {
            padding: 0 50px;
            margin-top: 89px;
            border-top: none;
            
            .up {
                width: 100%;
                min-width: none;
                height: 38px;
                background-color: @theme-color;
                font-size: 16px;
                border-radius: 18px;
            }
            .spacing-style {
                .van-button__content {
                    .van-button__text {
                        margin-left: 12px;
                        text-align: justify;
                        letter-spacing: 12px;
                    }
                }
            }
        }
    }
</style>